import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex, Tooltip, Typography, theme } from 'antd';
import LastSynced from './LastSynced';

const { Text } = Typography;

interface EstimateNoticeProps {
  lastSyncedTimeUTC?: string;
}

const EstimateNotice = ({ lastSyncedTimeUTC }: EstimateNoticeProps) => {
  const { token } = theme.useToken();

  return (
    <Flex align="center" justify="space-between" gap={token.marginSM} wrap>
      <Flex align="center" gap={token.marginSM}>
        <Tooltip title="Total downloads represent audio listens and video views.">
          <InfoCircleOutlined
            aria-hidden
            style={{ fontSize: token.fontSizeIcon, color: token.colorTextTertiary }}
          />
        </Tooltip>
        <Text style={{ fontSize: 11, color: token.colorTextTertiary }}>
          Represents estimates only. Verified downloads for today will be shown in the dashboard
          below tomorrow.
        </Text>
      </Flex>
      <LastSynced lastSyncedTimeUTC={lastSyncedTimeUTC} />
    </Flex>
  );
};

export default EstimateNotice;
